(function() {
  'use strict';

  angular
    .module('admin.explore.service', [])
    .factory('ExploreService', ExploreService);

  /** @ngInject */
  function ExploreService($http, $q, API) {

    function list(){
        var defered = $q.defer();

        $http.get(API.API_URL + 'admin/explore_screens')
          .success(defered.resolve)
          .error(defered.reject);

        return defered.promise;
    }


    function listSegments(id){
      var defered = $q.defer();

      $http.get(API.API_URL + 'admin/explore_screens/' + id + '/user_segments')
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function get(id){
      var defered = $q.defer();

      $http.get(API.API_URL + 'admin/explore_screens/' + id)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function create(model){
      var defered = $q.defer();

      $http.post(API.API_URL + 'admin/explore_screens', model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function addSegment(id, segmentId){
      var defered = $q.defer();

      $http.post(API.API_URL + 'admin/explore_screens/' + id + '/user_segments/' + segmentId)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function update(id, model){
      var defered = $q.defer();

      $http.put(API.API_URL + 'admin/explore_screens/' + id, model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function removeSegment(id, segmentId){
      var defered = $q.defer();

      $http.delete(API.API_URL + 'admin/explore_screens/' + id + '/user_segments/' + segmentId)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function remove(id){
      var defered = $q.defer();

      $http.delete(API.API_URL + 'admin/explore_screens/' + id)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function publish(id){
      var defered = $q.defer();

      $http.put(API.API_URL + 'admin/explore_screens/' + id + '/publish')
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function unpublish(id){
      var defered = $q.defer();

      $http.put(API.API_URL + 'admin/explore_screens/' + id + '/archive')
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function reorder(id, order){
      var defered = $q.defer();

      $http.put(API.API_URL + 'admin/explore_screens/' + id + '/order/' + order)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    return{
       list: list,
       listSegments: listSegments,
       get: get,
       addSegment: addSegment,
       create: create,
       update: update,
       removeSegment: removeSegment,
       remove: remove,
       publish: publish,
       unpublish: unpublish,
       reorder: reorder
    };

  }

})();
